<template lang="pug">
  .table-responsive
    table#tbSalidas.table.is-striped.is-fullwidth.is-narrow(v-show="hayDatos")
      thead
        tr
          th
            | #
          th 
            | Modelo
          th 
            | Resguarda
          th 
            | Ubicación
          th 
            | Placas
          th 
            | Tipo
          th 
            | Próximo Servicio
          th 
            | Verificación
      tbody
        tr(v-for="(v, index) in vehiculos" :key="v.id")
          td
            span.tag.is-black
              | {{ index + 1 }}
          td 
            span.tag.is-small
              | {{ v.descripcion }}
          td
            span.tag.is-small
              | {{ v.resguardo }}
          td
            span.tag.is-small
              | {{ v.ubicacion === 'LPGD' ? 'DUCTO' : v.ubicacion }}
          td
            span.tag.is-small 
              | {{ v.placas }}
          td 
            span.tag
              | {{ v.tipo }}
          td 
            span.tag {{ v.proximoServicio }}
          td
            span.tag.is-black {{ v.tipo_verificacion }}
            | &nbsp
            span.tag(:class="getClassVerificacion(v.verificacion)") {{ v.verificacion }}
    .notification(v-show="!hayDatos")
      strong  No registros para esta búsqueda.
</template>

<script>
  import moment from 'moment'

  export default {
    name: 'Tb_Vehiculos',
    props: {
      vehiculos: {
        type: Array,
        default: []
      },
    },
    data() {
      return {
        hayDatos: false,
        itemsSelected: {},
        isDisabled: true
      }
    },
    watch: {
      vehiculos() {
        this.checkDatos()
      }
    },
    methods: {
      iniciarComponente() {
        this.checkDatos()
      },
      checkDatos() {
        if (this.vehiculos.length > 0) {
          this.hayDatos = true
        } else {
          this.hayDatos = false
        }
      },
      getTipo(t) {
        let tipoStr = ''
        switch (parseInt(t)) {
          case 1:
            tipoStr = 'AUTOMOVIL'
            break
          case 2:
            tipoStr = 'CAMIONETA'
            break
          case 3:
            tipoStr = 'VAN'
            break
          case 4:
            tipoStr = 'TRACTOR'
            break
        
          default:
            tipoStr = ''
            break
        }
        return tipoStr 
      },

      getClassVerificacion (fecha) {
        let tipo = ''
        const hoy = moment()
        const fechaVerificacion = moment(fecha).startOf('month')
        const diasDiferencia = fechaVerificacion.diff(hoy, 'days')
        switch (true) {
          case diasDiferencia <= 7:
            tipo = 'is-danger'
            break
          case diasDiferencia <= 30 && diasDiferencia > 7:
            tipo = 'is-warning'
            break
        }
        return tipo
      },
    },
    created () {
      this.iniciarComponente()
    },
  }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/combustibles_Componentes/componentes/Tb_Vehiculos.vue